<router-outlet></router-outlet>
<div class="custom-backdrop" *ngIf="isShowSpinner">
    <div class="loading-icon" >
        <nz-spin >
            <nz-alert
              nzType="info"
            />
        </nz-spin>
    </div>
</div>

<img id="fileUpload" src="./assets/images/background/front-card.png" alt="" style="display: none;">
